<template>
  <div
    class="layout"
    :class="[computedCharacterColorClass]"
  >
    <!-- 梵字・家紋 + 俗名の表記（ラベル） + 俗名 + 享年表記 + 没年齢 + 没年齢単位 -->
    <div
      class="main"
      :class="{
        adjust: isBackSymbolAvailable,
      }"
    >
      <!-- 梵字・家紋 -->
      <div>
        <div
          v-if="isBackSymbolAvailable"
          class="symbol flex center"
        >
          <div class="box">
            <ImageResolver
              :src="computedBackSymbolSrc"
              class="character"
            />
          </div>
        </div>
      </div>

      <!-- スペーサー -->
      <div />

      <!-- 俗名の表記（ラベル） -->
      <div class="secularNamePrefixes">
        <!-- 俗名の表記（ラベル） > 霊ごと -->
        <div
          v-for="target in ['left', 'right']"
          :key="`secular-name-prefix-${target}`"
          class="secularNamePrefix flex center column"
          :class="{
            left: target === 'left',
            right: target === 'right',
          }"
        >
          <!-- 俗名の表記（ラベル） -->
          <TabletCharacterImage
            v-for="(character, index) in secularNamePrefix"
            :key="`character-${character}-${index}`"
            :char="character"
            :font="typography.font"
            :size="computedCharacterSize"
            @onClickCharacter="onClickCharacter({
              ...secularNamePrefixPayload,
              characterIndex: index,
              columnIndex: null,
              ...$event,
            })"
          />
        </div>
      </div>

      <!-- 俗名 -->
      <div class="secularNames">
        <div
          v-for="(column, columnIndex) in columns"
          :key="`secularName-${column.order}`"
          class="secularName flex align-center column justify-space-between"
          :class="{
            left: column.order === 2,
            right: column.order === 1,
          }"
        >
          <!-- 俗名 -->
          <TabletCharacterImage
            v-for="(character, index) in column.secularName"
            :key="`character-${character}-${index}`"
            :char="character"
            :font="typography.font"
            :size="computedCharacterSize"
            @onClickCharacter="onClickCharacter({
              ...secularNamePayload,
              characterIndex: index,
              columnIndex: columnIndex,
              ...$event,
            })"
          />
        </div>
      </div>

      <!-- 享年表示 -->
      <div class="ageAtDeathPrefixes">
        <!-- 享年表示 > 霊ごと -->
        <div
          v-for="(column, columnIndex) in columns"
          :key="`ageAtDeathPrefix-${column.order}`"
          class="ageAtDeathPrefix flex align-center column justify-space-between"
          :class="{
            left: column.order === 2,
            right: column.order === 1,
          }"
        >
          <!-- 享年表記 -->
          <TabletCharacterImage
            v-for="(character, index) in column.ageAtDeathPrefix"
            :key="`ageAtDeathPrefix-${character.character}-${index}`"
            :char="character"
            :font="typography.font"
            :size="computedCharacterSize"
            @onClickCharacter="onClickCharacter({
              ...ageAtDeathPrefixPayload,
              characterIndex: index,
              columnIndex: columnIndex,
              ...$event,
            })"
          />
        </div>
      </div>

      <!-- 没年齢 -->
      <div class="ageAtDeaths">
        <div
          v-for="(column, columnIndex) in columns"
          :key="`ageAtDeath-${column.order}`"
          class="ageAtDeath flex align-center column justify-space-between"
          :class="{
            left: column.order === 2,
            right: column.order === 1,
          }"
        >
          <!-- 没年齢 -->
          <TabletCharacterImage
            v-for="(character, index) in column.ageAtDeath"
            :key="`ageAtDeath-${character.character}-${index}`"
            :char="character"
            :font="typography.font"
            :size="computedCharacterSize"
            @onClickCharacter="onClickCharacter({
              ...ageAtDeathPayload,
              characterIndex: index,
              columnIndex: columnIndex,
              ...$event,
            })"
          />
        </div>
      </div>

      <!-- 没年齢単位 -->
      <div class="ageUnitCharacters">
        <div
          v-for="(column, columnIndex) in columns"
          :key="`ageUnitCharacter-${column.order}`"
          class="ageUnitCharacter flex align-center column justify-space-between"
          :class="{
            left: column.order === 2,
            right: column.order === 1,
          }"
        >
          <div class="box grow" />
          <!-- 没年齢単位 -->
          <TabletCharacterImage
            v-for="(character, index) in column.ageUnitCharacter"
            :key="`diedCharacter-${character.character}-${index}`"
            :char="character"
            :font="typography.font"
            :size="computedCharacterSize"
            @onClickCharacter="onClickCharacter({
              ...ageUnitCharacterPayload,
              characterIndex: index,
              columnIndex: columnIndex,
              ...$event
            })"
          />
        </div>
      </div>

      <!-- スペーサー -->
      <div />
    </div>

    <!-- 没年月日 -->
    <div
      class="side"
      :class="{
        adjust: isBackSymbolAvailable,
      }"
    >
      <!-- スペーサー（1fr） -->
      <div />

      <!-- 没年 + 没月 + 没日 -->
      <div class="dates">
        <div
          v-for="(column, columnIndex) in columns"
          :key="`date-${column.order}`"
          class="date flex align-center column justify-space-between"
          :class="{
            left: column.order === 2,
            right: column.order === 1,
          }"
        >
          <!-- 没年 -->
          <TabletCharacterImage
            v-for="(character, index) in column.dateOfDeathYear"
            :key="`deathYear-${character.character}-${index}`"
            :char="character"
            :font="typography.font"
            :size="computedSideCharacterSize"
            @onClickCharacter="onClickCharacter({
              ...dateOfDeathYearPayload,
              characterIndex: index,
              columnIndex: columnIndex,
              ...$event,
            })"
          />

           <!-- 没月 -->
          <TabletCharacterImage
            v-for="(character, index) in column.dateOfDeathMonth"
            :key="`deathMonth-${character.character}-${index}`"
            :char="character"
            :font="typography.font"
            :size="computedSideCharacterSize"
            @onClickCharacter="onClickCharacter({
              ...dateOfDeathMonthPayload,
              characterIndex: index,
              columnIndex: columnIndex,
              ...$event,
            })"
          />

          <!-- 没日 -->
          <TabletCharacterImage
            v-for="(character, index) in column.dateOfDeathDay"
            :key="`deathDay-${character.character}-${index}`"
            :char="character"
            :font="typography.font"
            :size="computedSideCharacterSize"
            @onClickCharacter="onClickCharacter({
              ...dateOfDeathDayPayload,
              characterIndex: index,
              columnIndex: columnIndex,
              ...$event,
            })"
          />
        </div>
      </div>

      <!-- 没表記 -->
      <div class="diedCharacters">
        <div
          v-for="column in columns"
          :key="`diedCharacter-${column.order}`"
          class="diedCharacter flex align-center column justify-space-between"
          :class="{
            left: column.order === 2,
            right: column.order === 1,
          }"
        >
          <!-- 没表記 -->
          <TabletCharacterImage
            v-for="(character, index) in diedCharacter"
            :key="`diedCharacter-${character.character}-${index}`"
            :char="character"
            :font="typography.font"
            :size="computedSideCharacterSize"
            @onClickCharacter="onClickCharacter({
              ...diedCharacterPayload,
              characterIndex: index,
              columnIndex: null,
              ...$event,
            })"
          />
        </div>
      </div>

      <!-- スペーサー（1fr） -->
      <div />
    </div>
  </div>
</template>

<script>
import TabletPreviewMixin from "@/mixins/tabletPreview.mixin";

export default {
  mixins: [
    TabletPreviewMixin.back,
    TabletPreviewMixin.character,
  ],
  components: {
  },
  props: {
  },
  mounted () {},
  data () {
    return {
    };
  },
  computed: {
    // 俗名の表記（ラベル）+ 俗名 + 享年表記 + 没年齢 + 没年齢単位
    // の文字列の長さから要素一つあたりのサイズを算出
    computedCharacterSize () {
      const {
        isBackSymbolAvailable,
        ageAtDeathPrefixPlacement,
        columns,
        secularNamePrefix,
      } = this;

      const defaultSize = 20;
      const maxHeight = !isBackSymbolAvailable ? 400 - 10 * 6 - 10 - 15 : 320 - 10 * 6 - 15;

      const rightAgeUnitCharacterLength = columns[0].ageUnitCharacter ? columns[0].ageUnitCharacter.length : 0;
      const leftAgeUnitCharacterLength = columns[1].ageUnitCharacter ? columns[1].ageUnitCharacter.length : 0;
      const ageUnitCharacterLength = Math.max(rightAgeUnitCharacterLength, leftAgeUnitCharacterLength);
      const rightAgeDeathPrefix = columns[0].ageAtDeathPrefix ? columns[0].ageAtDeathPrefix.length : 0;
      const leftAgeDeathPrefix = columns[1].ageAtDeathPrefix ? columns[1].ageAtDeathPrefix.length : 0;
      const ageAtDeathPrefixLength = ageAtDeathPrefixPlacement === "EACH_COLUMN"
        ? rightAgeDeathPrefix
        : Math.max(rightAgeDeathPrefix, leftAgeDeathPrefix);
      const rightCharacterLength = columns[0].secularName.length + secularNamePrefix.length + ageAtDeathPrefixLength + columns[0].ageAtDeath.length + ageUnitCharacterLength;
      const leftCharacterLength = columns[1].secularName.length + secularNamePrefix.length + ageAtDeathPrefixLength + columns[1].ageAtDeath.length + ageUnitCharacterLength;
      const characterLength = Math.max(rightCharacterLength, leftCharacterLength);
      const characterSize = maxHeight / characterLength;
      const size = Math.min(defaultSize, characterSize);

      return size;
    },

    // 没年月日 + 没年齢単位
    // の文字列の長さから要素一つあたりのサイズを算出
    computedSideCharacterSize () {
      const {
        isBackSymbolAvailable,
        columns,
        diedCharacter,
      } = this;

      const defaultSize = 20;
      const maxHeight = !isBackSymbolAvailable ? 400 - 15 - 15 : 320 - 15;

      const rightDateOfDeathLength = columns[0].dateOfDeath.length || 0;
      const leftDateOfDeathLength = columns[1].dateOfDeath.length || 0;
      const rightCharacterLength = rightDateOfDeathLength + diedCharacter.length;
      const leftCharacterLength = leftDateOfDeathLength + diedCharacter.length;
      const characterLength = Math.max(rightCharacterLength, leftCharacterLength);
      const characterSize = maxHeight / characterLength;
      const size = Math.min(defaultSize, characterSize);

      return size;
    },
  },
  watch: {},
  destroyed () {},
  methods: {},
};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/variables.scss";
@import "~@/assets/styles/tablet-front.scss";

.layout {
  height: 100%;
  width: 100%;
  box-sizing: border-box;
  overflow: hidden;

  .main {
    display: grid;
    grid-template-rows: auto 1fr auto auto auto auto auto 15px;
    grid-template-columns: 1fr;
    gap: 10px;
    height: 100%;
    width: 60px;
    position: absolute;
    top: 0;
    left: -60px;
    box-sizing: border-box;
    overflow-x: visible;
    z-index: 1;

    &.adjust {
      grid-template-rows: auto 1fr auto auto auto auto auto 15px;
      gap: 10px;
      // padding-bottom: 30px; // (80 - 50) / 2
    }

    @include symbol(105px); // (150 + 60) / 2

    .secularNamePrefixes {
      height: 100%;
      width: 100%;
      position: relative;
      box-sizing: border-box;

      .secularNamePrefix {
        height: 100%;
        transform: translateX(105px);

        &.left {
          float: left;
          transform: translateX(80px);
        }

        &.right {
          float: right;
        }

        @include character(25px);
      }
    }

    .secularNames {
      height: 100%;
      width: 100%;
      position: relative;
      box-sizing: border-box;

      .secularName {
        height: 100%;
        transform: translateX(105px);

        &.left {
          float: left;
          transform: translateX(80px);
        }

        &.right {
          float: right;
        }

        @include character(25px);
      }
    }

    .ageAtDeathPrefixes,
    .ageAtDeaths,
    .ageUnitCharacters {
      height: 100%;
      width: 100%;
      position: relative;
      box-sizing: border-box;

      .ageAtDeathPrefix,
      .ageAtDeath,
      .ageUnitCharacter {
        height: 100%;
        transform: translateX(105px);

        &.left {
          float: left;
          transform: translateX(80px);
        }

        &.right {
          float: right;
        }

        @include character(25px);
      }
    }
  }

  .side {
    display: grid;
    grid-template-rows: 15px auto auto 1fr;
    grid-template-columns: 1fr;
    height: 100%;
    position: relative;
    box-sizing: border-box;
    padding: 0 2.5px;

    &.adjust {
      grid-template-rows: 80px auto auto 1fr;
    }

    .dates,
    .diedCharacters {
      height: 100%;
      width: 100%;
      position: relative;

      &.adjust {
        padding-top: 15px;
      }

      .date,
      .diedCharacter {
        height: 100%;
        width: 35px;

        &.left {
          float: left;
          transform: translateX(35px);
        }

        &.right {
          float: right;
          transform: translateX(-10px);
        }

        @include character(20px);
      }
    }
  }
}
</style>
